import { render, staticRenderFns } from "./gCrud.vue?vue&type=template&id=08e04c37&scoped=true"
import script from "./gCrud.vue?vue&type=script&lang=js"
export * from "./gCrud.vue?vue&type=script&lang=js"
import style0 from "./gCrud.vue?vue&type=style&index=0&id=08e04c37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e04c37",
  null
  
)

export default component.exports